import {RoleTypesList} from "./RoleTypesList";
import {RoleTypesEdit} from "./RoleTypesEdit";
import {RoleTypesCreate} from "./RoleTypesCreate";

export default {
    list: RoleTypesList,
    create: RoleTypesCreate,
    edit: RoleTypesEdit
};
